export default __webpack_public_path__ + "static/media/new.349274fb.png";